<template>
  <WebccIcon
    v-tooltip="tooltip"
    name="site/info-new"
    class="w-4 h-4 text-txt-weak"
    @click.stop
  />
</template>

<script setup lang="ts">
const tooltip = usePriceLegalInfoTooltip()
</script>
